var _a;
/**
 * Default URI to API service
 */
export const DEFAULT_API_SERVICE_URI = (_a = process.env.API_SERVICE_URI) !== null && _a !== void 0 ? _a : '/api';
